import React from 'react';
import { AlertModel as ModelFactory } from '@leverege/recovr-models';
import { camelCaseToTitleCase, capitalize } from '@leverege/string-util';
import { Flex } from '@leverege/ui-elements';
import CheckboxEditor from './atomicEditors/CheckboxEditor';
import NumericInputEditor from './atomicEditors/NumericInputEditor';
import ToggleEditor from './atomicEditors/ToggleEditor';
import { getModelFromFactory } from '../../util/Model';
import S from './AlertEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function AlertEditor(props) {
  const {
    kind,
    value,
    editableValues = []
  } = props;
  const Model = getModelFromFactory(ModelFactory);
  const activeLabel = `Receive ${camelCaseToTitleCase(value.type.split('.').slice(-1)[0])} ${capitalize(kind)}s`;
  const thresholdLabel = 'Miles from Location';
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    className: S.space,
    children: [editableValues.includes('active') && /*#__PURE__*/_jsx(ToggleEditor, {
      valueKey: "active",
      label: activeLabel,
      ...props
    }), editableValues.includes('threshold') && /*#__PURE__*/_jsx(NumericInputEditor, {
      valueKey: "threshold",
      label: thresholdLabel,
      ...props
    }), editableValues.includes('vehicleTypes') && /*#__PURE__*/_jsx("div", {
      className: S.grid,
      children: Model.vehicleTypes.map(type => /*#__PURE__*/_jsx(CheckboxEditor, {
        valueKey: type,
        label: capitalize(type),
        ...props
      }, type))
    })]
  });
}